import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo/torqai-logo.svg";
import MegaMenu1 from "./MegaMenu1";
import MegaMenuServices from "./MegaMenu2";
import MobileMenu from "../MobileMenu/MobileMenu";
import TopBanner from "./TopBanner";

const Header: React.FC = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);
  const lastScrollY = useRef<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      // Scroll up → show sticky smoothly
      if (currentScroll < lastScrollY.current && currentScroll > 100) {
        setIsSticky(true);
        setTimeout(() => setIsVisible(true), 10); // delay for smooth entrance
      }
      // Scroll down → hide sticky instantly
      else if (currentScroll > lastScrollY.current) {
        setIsVisible(false);
        setTimeout(() => setIsSticky(false), 100); // small delay for hide
      }

      // Reset if near top
      if (currentScroll <= 100) {
        setIsSticky(false);
        setIsVisible(false);
      }

      lastScrollY.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const handleSubmit = (e: React.FormEvent) => e.preventDefault();

  return (
    <>
      <style>{`
        @media (max-width: 390px) {
          .mobile-header-actions {
            gap: 6px !important;
          }
          .mobile-try-btn {
            padding: 4px 4px 4px 10px !important;
            font-size: 11px !important;
          }
          .xb-header-logo img {
            max-width: 110px !important;
          }
        }
      `}</style>
      <TopBanner />
      <header
        id="xb-header-area"
        className="header-area header-style--one header-transparent is-sticky wow fadeInDown"
        data-wow-delay="0ms"
        data-wow-duration="600ms"
        style={{ 
          zIndex: mobileActive ? 0 : 9999,
          pointerEvents: mobileActive ? "none" : "auto"
        }}
      >

      <div
        className={`xb-header xb-sticky-stt ${
          isSticky ? "xb-header-area-sticky" : ""
        } ${isVisible ? "xb-header-fixed" : "xb-header-hidden"}`}
        style={{ 
          opacity: mobileActive ? 0 : 1,
          visibility: mobileActive ? "hidden" : "visible",
          pointerEvents: mobileActive ? "none" : "auto",
          transition: "opacity 0.3s ease, visibility 0.3s ease"
        }}
      >
        <div className="container mxw-1650">
          <div className="header__wrap ul_li_between">
            {/* Logo */}
            <div className="xb-header-logo">
              <Link to="/" className="logo1" onClick={handleClick}>
                <img src={logo} alt="Logo" />
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="main-menu__wrap navbar navbar-expand-lg p-0">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li className="active">
                    <Link to="/" onClick={handleClick}>
                      <span>Home</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/about" onClick={handleClick}>
                      <span>About Us</span>
                    </Link>
                  </li>

                  <li className="menu-item-has-children megamenu">
                    <Link to="#" onClick={handleClick}>
                      <span>Products</span>
                    </Link>
                    <MegaMenuServices />
                  </li>

                  <li>
                    <Link to="/pricing" onClick={handleClick}>
                      <span>Pricing</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/case-studies" onClick={handleClick}>
                      <span>Case Studies</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/contact" onClick={handleClick}>
                      <span>Contact Us</span>
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* Button */}
            <div className="header-btn">
              <a 
                href="https://dashboard.torqai.ca/" 
                className="login-btn" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Log in
              </a>
              <a 
                href="https://dashboard.torqai.ca/" 
                className="thm-btn" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Try For Free
              </a>
            </div>

            {/* Mobile Toggle */}
            <div className="d-lg-none mobile-header-actions" style={{ display: "flex", alignItems: "center", gap: "15px" }}>
              <a 
                href="https://dashboard.torqai.ca/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="mobile-try-btn"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: "#ba69e9", 
                  color: "#000", 
                  borderRadius: "50px", 
                  padding: "6px 6px 6px 16px",
                  fontWeight: 700,
                  fontSize: "13px",
                  border: "none",
                  textDecoration: "none",
                  gap: "8px",
                  transition: "0.3s",
                  whiteSpace: "nowrap"
                }}
              >
                Try For Free
                <div 
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#000",
                    width: "28px",
                    height: "28px",
                    minWidth: "28px",
                    flexShrink: 0,
                    borderRadius: "50%"
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white"/>
                    <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white"/>
                    <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white"/>
                    <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white"/>
                    <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white"/>
                    <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white"/>
                    <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white"/>
                  </svg>
                </div>
              </a>
              <div className="header-bar-mobile side-menu">
                <button
                  className="xb-nav-mobile"
                  onClick={() => setMobileActive(!mobileActive)}
                >
                  <i className="far fa-bars"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

      {/* Mobile Menu */}
      <div className="xb-header-wrap">
        <div className={`xb-header-menu ${mobileActive ? "active" : ""}`}>
          <div className="xb-header-menu-scroll" style={{ display: 'flex', flexDirection: 'column', height: '100dvh', position: 'relative', paddingTop: '20px' }}>
            <div className="mobile-menu-top-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 20px' }}>
              <div className="xb-logo-mobile xb-hide-xl" style={{ margin: 0, padding: 0 }}>
                <Link to="/" rel="home" onClick={() => setMobileActive(false)}>
                  <img src={logo} alt="Logo" style={{ maxWidth: '120px' }} />
                </Link>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <a 
                  href="https://dashboard.torqai.ca/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mobile-login-btn"
                  style={{ 
                    color: "#fff", 
                    fontWeight: 500,
                    fontSize: "14px",
                    textDecoration: "none",
                    background: "rgba(255,255,255,0.1)",
                    padding: "8px 20px",
                    borderRadius: "20px"
                  }}
                  onClick={() => setMobileActive(false)}
                >
                  Log in
                </a>
                <button
                  className="xb-menu-close xb-hide-xl"
                  onClick={() => setMobileActive(false)}
                  style={{ position: 'relative', top: 'auto', right: 'auto', background: 'transparent', border: 'none', margin: 0, width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}
                  aria-label="Close Menu"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#ba69e9" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <nav className="xb-header-nav" style={{ flexGrow: 1, paddingTop: '30px', overflowY: 'auto', paddingLeft: '20px', paddingRight: '20px' }}>
              <MobileMenu closeMenu={() => setMobileActive(false)} />
            </nav>

            <div className="xb-header-mobile-btn text-center" style={{ padding: '20px', marginTop: 'auto', width: '100%', boxSizing: 'border-box', background: 'rgba(17, 18, 29, 0.85)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)' }}>
              <a 
                href="https://dashboard.torqai.ca/" 
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  display: "block",
                  color: "#000", 
                  background: "#ba69e9",
                  fontWeight: 700,
                  fontSize: "16px",
                  padding: "15px",
                  borderRadius: "10px",
                  textDecoration: "none"
                }}
                onClick={() => setMobileActive(false)}
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
        <div className="xb-header-menu-backdrop" onClick={() => setMobileActive(false)}></div>
      </div>
    </>
  );
};

export default Header;
